import { Flex, Heading, useBoolean } from '@chakra-ui/react'

import { ContractsExportForm } from '@/containers/export/ContractsExportForm'
import type { InsuranceParamsPagedQuery } from 'BrokerTsLib/src/dtos'
import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { createContext, useEffect, useState } from 'react'
import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { ContractsList } from '../../containers/contracts'
import { ExportButton } from '../../containers/export/ExportButton'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { ContractsPropertySearch } from '../../containers/search/chaloupka/ContractsPropertySearch'
import { SearchButton } from '../../containers/search/SearchButton'
import { useGetAll } from '../../hooks/useInsuranceParams'

export const contractsPropertyContext = createContext<IPaginationContext<InsuranceParamsPagedQuery>>({} as IPaginationContext<InsuranceParamsPagedQuery>)

export const ContractsPropertyPage = () => {
  const [isSearchOpen, setSearchOpen] = useBoolean(false)
  const [isExportOpen, setExportOpen] = useBoolean(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [filter, setFilter] = useState<InsuranceParamsPagedQuery>({
    //dateCreatedFrom: defaultDateFrom,
    listType: 2,
    pageIndex: 1,
  })

  const { data, mutateAsync: getAllAsync, isPending: isLoading } = useGetAll()
  const items = data?.data

  useEffect(() => {
    setFilter({ ...filter, pageSize: pageSize, pageIndex: currentPage })
  }, [pageSize, currentPage])

  useEffect(() => {
    if (filter.pageSize) // nechci spoustet nacitani na pageload 2x
      getAllAsync(filter)
  }, [filter])

  return (
    <Section>
      <Container>
        <PageContent>
          <contractsPropertyContext.Provider value={
            {
              loading: isLoading,
              totalCount: items?.totalCount ?? 0,
              currentPage: currentPage,
              pageSize: pageSize,
              filter: filter,
              setCurrentPage: setCurrentPage,
              setPageSize: setPageSize,
              updateFilter: f => setFilter(f),
              reload: () => { }
            }
          }>
            <PageToolbar
              leftElements={
                <Flex sx={{ gap: 4, alignItems: 'center' }}>
                  <Heading as="h1">Smlouvy</Heading>
                </Flex>
              }
              rightElements={
                <Flex sx={{ gap: 4 }}>
                  <ExportButton isOpen={isExportOpen} setOpen={setExportOpen} />
                  <SearchButton isOpen={isSearchOpen} setOpen={setSearchOpen} />
                </Flex>
              }
            />

            {isSearchOpen && <ContractsPropertySearch />}
            {isExportOpen && <ContractsExportForm />}

            <ContractsList contracts={items?.items ?? []} withPaginator />
          </contractsPropertyContext.Provider>
        </PageContent>
      </Container>
    </Section>
  )
}
